var a = document.getElementById('map');
if (typeof (a) != 'undefined' && a != null) {
    setTimeout(() => {
        initMap();
    }, '300');
}

function initMap() {
    var svgDoc = a.contentDocument;
    var links = {
        'blekinge': '/distrikt/blekinge',
        'dalarna': '/distrikt/dalarna',
        'gavleborg': '/distrikt/gavleborg',
        'gotland': '/distrikt/stockholm',
        'halland': '/distrikt/halland',
        'jamtland-harjedalen': '/distrikt/jamtland-harjedalen',
        'jonkoping': '/distrikt/jonkoping',
        'kalmar': '/distrikt/kalmar',
        'kronoberg': '/distrikt/kronoberg',
        'norrbotten': '/distrikt/norrbotten',
        'orebro': '/distrikt/orebro',
        'ostergotland': '/distrikt/ostergotland',
        'skane': '/distrikt/skane',
        'sormland': '/distrikt/sormland',
        'stockholm': '/distrikt/stockholm',
        'uppsala': '/distrikt/uppsala',
        'varmland': '/distrikt/varmland',
        'vasterbotten': '/distrikt/vasterbotten',
        'vasternorrland': '/distrikt/vasternorrland',
        'vastmanland': '/distrikt/vastmanland',
        'vastra-gotaland': '/distrikt/vastra-gotaland',
    };
    // Get all path elements in the SVG
    var paths = svgDoc.getElementsByTagName('path');

    // Function to highlight the path corresponding to a district
    function highlightPath(district) {
        for (var i = 0; i < paths.length; i++) {
            var pathId = paths[i].getAttribute('data-id');
            if (pathId === district) {
                paths[i].style.fill = '#A0C371'; // Highlight the path

            } else {
                paths[i].style.fill = ''; // Clear highlight from other paths
            }
        }
    }

    // Function to highlight the district link corresponding to a district
    function highlightLink(district) {
        var districtLinks = document.getElementsByClassName('district-link');
        for (var i = 0; i < districtLinks.length; i++) {
            var linkDistrict = districtLinks[i].getAttribute('data-district');
            if (linkDistrict === district) {
                districtLinks[i].style.color = '#A0C371'; // Highlight the link
                districtLinks[i].classList.add('active');
            } else {
                districtLinks[i].style.color = ''; // Clear highlight from other links
                districtLinks[i].classList.remove('active');
            }
        }
    }

    // Add event listeners to each district link
    var districtLinks = document.getElementsByClassName('district-link');
    for (var i = 0; i < districtLinks.length; i++) {
        districtLinks[i].addEventListener('mouseenter', function() {
            var district = this.getAttribute('data-district');
            highlightPath(district); // Highlight the corresponding path
            highlightLink(district); // Highlight the corresponding link
        });
        districtLinks[i].addEventListener('mouseleave', function() {
            var district = this.getAttribute('data-district');
            highlightPath(''); // Revert highlight from the path
            highlightLink(''); // Clear highlight from all links
        });
    }
    // Add event listeners to each path to highlight corresponding link on hover
    for (var i = 0; i < paths.length; i++) {
        paths[i].addEventListener('mouseenter', function() {
            var district = this.getAttribute('data-id');
            highlightPath(district); // Highlight the path
            highlightLink(district); // Highlight the corresponding link
        });
        paths[i].addEventListener('mouseleave', function() {
            highlightPath(''); // Clear highlight from all paths
            highlightLink(''); // Clear highlight from all links
        });
        paths[i].addEventListener('click', function() {
            var district = this.getAttribute('data-id');
            var link = links[district];
            if (link) {
                window.location.href = link; // Redirect to the corresponding link
            }
        });
    }
}
//# sourceMappingURL=district-map.js.map
